export const calculateAroundTheWorldDestination = (miles) => {
  if (miles < 4919) {
    return { current: 'Edinburgh', next: 'Zanzibar' };
  }
  if (miles >= 4919 && miles <= 8396) {
    return { current: 'Zanzibar', next: 'Delhi' };
  }
  if (miles > 8396 && miles <= 10728) {
    return { current: 'Delhi', next: 'Hong Kong' };
  }
  if (miles > 10728 && miles <= 12533) {
    return { current: 'Hong Kong', next: 'Tokyo' };
  }
  if (miles > 12533 && miles <= 18008) {
    return { current: 'Tokyo', next: 'Auckland' };
  }
  if (miles > 18008 && miles <= 24524) {
    return { current: 'Auckland', next: 'San Francisco' };
  }
  if (miles > 24524 && miles <= 27110) {
    return { current: 'San Francisco', next: 'New York' };
  }
  if (miles > 27110 && miles <= 30364.99) {
    return { current: 'New York', next: 'Edinburgh' };
  }
  if (miles >= 30365) {
    return { current: 'COMPLETED', next: 'COMPLETED' };
  }
};
